export default {
    'name': 'licensing',
    'label': 'legal.tabs.Licensing',
    'getComponent': () => import('./licensing.vue'),
    'tabIndex': 3,
    'left': false,
    'right': false,
    'singleView': true,
    'exclusiveRoutePath': '/legal/licensing',
};
